(() => {
  const MAX_QTY = 20;
  const MESSAGE = 'Bir üründen en fazla 20 adet ekleyebilirsiniz.';
  const QUANTITY_CONTAINER_SELECTOR = 'quantity-input, .quantity, .quantity-input, .product-form__quantity, .cart-item__quantity';
  const QUANTITY_INPUT_SELECTOR = 'input[name="quantity"], input[name="updates[]"], .quantity__input';

  function isQuantityInput(input) {
    if (!input || input.type === 'hidden') return false;
    if (input.matches(QUANTITY_INPUT_SELECTOR)) return true;

    return input.matches('input[type="number"]') && Boolean(input.closest(QUANTITY_CONTAINER_SELECTOR));
  }

  function getQtyInputFromButton(button) {
    const quantity = button.closest(QUANTITY_CONTAINER_SELECTOR);
    if (!quantity) return null;
    return quantity.querySelector(`${QUANTITY_INPUT_SELECTOR}, input[type="number"]`);
  }

  function normalizeInput(input) {
    if (!isQuantityInput(input)) return;
    const max = Number(input.getAttribute('max'));
    if (!max || max > MAX_QTY) input.setAttribute('max', String(MAX_QTY));
    input.setAttribute('data-kozbino-max-qty', String(MAX_QTY));
    const value = Number(input.value || 0);
    if (value > MAX_QTY) {
      input.value = MAX_QTY;
      input.setCustomValidity(MESSAGE);
      input.reportValidity?.();
      setTimeout(() => input.setCustomValidity(''), 1200);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      input.setCustomValidity('');
    }
  }

  function clampQuantityInputs(context = document) {
    context.querySelectorAll(`${QUANTITY_INPUT_SELECTOR}, ${QUANTITY_CONTAINER_SELECTOR} input[type="number"]`).forEach(normalizeInput);
  }

  function clampForm(form) {
    const input = form.querySelector('input[name="quantity"], .quantity__input');
    if (!input) return true;
    const value = Number(input.value || 1);
    if (value > MAX_QTY) {
      input.value = MAX_QTY;
      input.setCustomValidity(MESSAGE);
      input.reportValidity?.();
      setTimeout(() => input.setCustomValidity(''), 1400);
      return false;
    }
    return true;
  }

  document.addEventListener('input', (event) => {
    if (isQuantityInput(event.target)) {
      normalizeInput(event.target);
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (isQuantityInput(event.target)) {
      normalizeInput(event.target);
    }
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('button, a');
    if (!button) return;
    const text = (button.textContent || '').trim();
    const aria = button.getAttribute('aria-label') || '';
    const isPlus = button.name === 'plus' || /artır|increase|plus|\+/.test(`${text} ${aria}`.toLowerCase());
    if (!isPlus) return;
    const input = getQtyInputFromButton(button);
    if (!input) return;
    normalizeInput(input);
    if (Number(input.value || 0) >= MAX_QTY) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.setCustomValidity(MESSAGE);
      input.reportValidity?.();
      setTimeout(() => input.setCustomValidity(''), 1400);
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"], form[is="product-form"], product-form form')) return;
    if (!clampForm(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  const originalFetch = window.fetch;
  window.fetch = function(resource, init = {}) {
    try {
      const url = typeof resource === 'string' ? resource : resource?.url || '';
      const isCartAdd = url.includes('/cart/add');
      const isCartChange = url.includes('/cart/change');
      const isCartUpdate = url.includes('/cart/update');
      if ((isCartAdd || isCartChange || isCartUpdate) && init && init.body) {
        if (init.body instanceof FormData) {
          const nextBody = new FormData();
          init.body.forEach((value, key) => {
            if ((key === 'quantity' || key === 'updates[]') && Number(value) > MAX_QTY) {
              nextBody.append(key, String(MAX_QTY));
            } else {
              nextBody.append(key, value);
            }
          });
          init.body = nextBody;
        } else if (typeof init.body === 'string' && init.headers && String(init.headers['Content-Type'] || init.headers.get?.('Content-Type') || '').includes('application/json')) {
          const data = JSON.parse(init.body);
          if (Number(data.quantity) > MAX_QTY) data.quantity = MAX_QTY;
          if (Array.isArray(data.items)) {
            data.items.forEach((item) => {
              if (Number(item.quantity) > MAX_QTY) item.quantity = MAX_QTY;
            });
          }
          if (Array.isArray(data.updates)) {
            data.updates = data.updates.map((quantity) => Number(quantity) > MAX_QTY ? MAX_QTY : quantity);
          } else if (data.updates && typeof data.updates === 'object') {
            Object.keys(data.updates).forEach((key) => {
              if (Number(data.updates[key]) > MAX_QTY) data.updates[key] = MAX_QTY;
            });
          }
          init.body = JSON.stringify(data);
        }
      }
    } catch (error) {}
    return originalFetch.call(this, resource, init);
  };


  function getUpsellStep(track) {
    const card = track.querySelector('.kozbino-cart-upsell__card');
    const styles = window.getComputedStyle(track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 12;
    return card ? card.getBoundingClientRect().width + gap : Math.max(track.clientWidth * 0.8, 180);
  }

  function isInteractiveUpsellTarget(target) {
    return Boolean(
      target.closest?.('a, button, input, select, textarea, label, summary, form, [role="button"], [role="link"], [contenteditable="true"]')
    );
  }

  function updateUpsellSlider(slider) {
    const track = slider.querySelector('[data-kozbino-upsell-track]');
    const prev = slider.querySelector('.kozbino-cart-upsell__nav--prev');
    const next = slider.querySelector('.kozbino-cart-upsell__nav--next');
    if (!track || !prev || !next) return;

    const isScrollable = track.scrollWidth > track.clientWidth + 4;
    slider.classList.toggle('is-scrollable', isScrollable);
    prev.disabled = !isScrollable || track.scrollLeft <= 4;
    next.disabled = !isScrollable || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  }

  function initUpsellSliders(context = document) {
    const foundSliders = context.querySelectorAll?.('[data-kozbino-upsell-slider]') || [];
    const sliders = [
      ...(context.matches?.('[data-kozbino-upsell-slider]') ? [context] : []),
      ...foundSliders
    ];
    sliders.forEach((slider) => {
      const track = slider.querySelector('[data-kozbino-upsell-track]');
      const prev = slider.querySelector('.kozbino-cart-upsell__nav--prev');
      const next = slider.querySelector('.kozbino-cart-upsell__nav--next');
      if (!track || !prev || !next) return;

      if (slider.dataset.kozbinoSliderReady === 'true') {
        updateUpsellSlider(slider);
        return;
      }
      slider.dataset.kozbinoSliderReady = 'true';

      prev.addEventListener('click', (event) => {
        event.preventDefault();
        track.scrollBy({ left: -getUpsellStep(track), behavior: 'smooth' });
      });

      next.addEventListener('click', (event) => {
        event.preventDefault();
        track.scrollBy({ left: getUpsellStep(track), behavior: 'smooth' });
      });

      let isDown = false;
      let startX = 0;
      let startScrollLeft = 0;
      let moved = false;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (isInteractiveUpsellTarget(event.target)) return;
        isDown = true;
        moved = false;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(event.pointerId); } catch (error) {}
      });

      track.addEventListener('pointermove', (event) => {
        if (!isDown) return;
        const diff = event.clientX - startX;
        if (Math.abs(diff) > 4) {
          moved = true;
          event.preventDefault();
        }
        track.scrollLeft = startScrollLeft - diff;
      });

      ['pointerup', 'pointercancel', 'pointerleave'].forEach((eventName) => {
        track.addEventListener(eventName, () => {
          if (!isDown) return;
          isDown = false;
          track.classList.remove('is-dragging');
          setTimeout(() => { moved = false; }, 80);
        });
      });

      track.addEventListener('click', (event) => {
        if (!moved) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);

      track.addEventListener('scroll', () => window.requestAnimationFrame(() => updateUpsellSlider(slider)), { passive: true });

      // Görseller geç yüklendiğinde okların pasif kalmaması için yeniden ölç.
      track.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', () => updateUpsellSlider(slider), { once: true });
        image.addEventListener('error', () => updateUpsellSlider(slider), { once: true });
      });

      if (typeof ResizeObserver === 'function') {
        const resizeObserver = new ResizeObserver(() => updateUpsellSlider(slider));
        resizeObserver.observe(track);
      }

      updateUpsellSlider(slider);
      setTimeout(() => updateUpsellSlider(slider), 250);
      setTimeout(() => updateUpsellSlider(slider), 900);
    });
  }


  function syncKozbinoCartDrawerState() {
    const drawer = document.getElementById('CartDrawer');
    document.body.classList.toggle('kozbino-cart-drawer-open', Boolean(drawer && drawer.hasAttribute('open')));
  }

  function observeKozbinoCartDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.dataset.kozbinoDrawerObserver === 'true') return;
    drawer.dataset.kozbinoDrawerObserver = 'true';
    const observer = new MutationObserver(syncKozbinoCartDrawerState);
    observer.observe(drawer, { attributes: true, attributeFilter: ['open', 'hidden'] });
    syncKozbinoCartDrawerState();
  }


  document.addEventListener('DOMContentLoaded', () => {
    clampQuantityInputs();
    initUpsellSliders();
    observeKozbinoCartDrawer();
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            clampQuantityInputs(node);
            initUpsellSliders(node);
            observeKozbinoCartDrawer();
            syncKozbinoCartDrawerState();
          }
        });
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  });

  window.addEventListener('resize', () => setTimeout(() => initUpsellSliders(), 100));
  document.addEventListener('shopify:section:load', (event) => initUpsellSliders(event.target));
  document.addEventListener('cart:updated', () => {
    setTimeout(clampQuantityInputs, 50);
    setTimeout(() => initUpsellSliders(), 80);
  });
  document.addEventListener('cart:refresh', () => {
    setTimeout(clampQuantityInputs, 50);
    setTimeout(() => initUpsellSliders(), 80);
    setTimeout(() => { observeKozbinoCartDrawer(); syncKozbinoCartDrawerState(); }, 90);
  });
  document.addEventListener('drawer:handleAfterShow', syncKozbinoCartDrawerState);
  document.addEventListener('drawer:handleAfterHide', syncKozbinoCartDrawerState);
})();
